import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Toast from 'Services/Toast';
import { rootActions } from 'Store';
import { selectDocument } from 'Utils/selectors';

import useDocumentInteractInit from './useDocumentInteractInit';

export default (documentId: string) => {
  const [initDocumentInteract, isDocumentInteractLoading] = useDocumentInteractInit();
  const currentDocument = useSelector(state => selectDocument(state, { documentId }));

  const dispatch = useDispatch();

  const setConvertedDocument = useCallback(async () => {
    try {
      if (!currentDocument) {
        return Toast.error('Document not found');
      }

      const [pdfUrls] = await initDocumentInteract({
        document: currentDocument,
      });

      dispatch(
        rootActions.documentInteract.setPdfFiles({
          documentId,
          files: pdfUrls,
        }),
      );
    } catch (error) {
      Toast.handleErrors(error);
    }
  }, [dispatch, initDocumentInteract, currentDocument, documentId]);

  useEffect(() => {
    setConvertedDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(rootActions.documentInteract.clearDocumentInteract(documentId));
    };
  }, [dispatch, documentId]);

  return isDocumentInteractLoading;
};
